import { render } from "./CampaignSummary.vue?vue&type=template&id=6019443e&scoped=true"
import script from "./CampaignSummary.vue?vue&type=script&lang=js"
export * from "./CampaignSummary.vue?vue&type=script&lang=js"

import "./CampaignSummary.vue?vue&type=style&index=0&id=6019443e&scoped=true&lang=css"

import exportComponent from "/Users/bytedance/New/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6019443e"]])

export default __exports__